import { usePermissionsStore } from "../../permissions/permissions_store";
import classnames from "classnames";
import moment from "moment";
import { Image } from "uikit-react";

import FeatherIcon from "../../common/FeatherIcon";

export const ReservationThreadCard = ({
	reservation,
	selected,
	handleSelect,
	togglePersonalMeta,
	setPersonalMeta,
	setReservation,
	isMetaPending,
}) => {
  const { canEdit } = usePermissionsStore();
  const canManage = canEdit("messaging.messages");
	const isUnread = reservation.thread_meta?.indexOf("unread") >= 0;
	const readPending = isMetaPending(reservation.thread_id, "unread");
	const priorityPending = isMetaPending(reservation.thread_id, "priority");
	const archivePending = isMetaPending(reservation.thread_id, "archived");

	return (
		<div
			className={classnames("chat-guest-contact-wrapper", {
				"active-chat-guest-contact": selected,
				"thread-unread": isUnread,
			})}
			key={reservation.thread_id}
			onClick={() => {
				handleSelect(reservation.thread_id);
				setReservation(reservation);
			}}
		>
			<div className="message-text-group">
				<Image src="/images/guest-active.svg" />
				<div>
					<div className="chat-guest-contact-name">
						{reservation.first_name} {reservation.last_name}
					</div>
					{/* <div className="chat-guest-contact-address">
              {reservation.pms_id}
            </div> */}
					<div className="chat-guest-contact-date">
						{reservation.last_message_on
							? moment
									.utc(reservation.last_message_on)
									.local()
									.format("MMM DD, YYYY hh:mm a")
							: "No messages yet"}
					</div>
				</div>
			</div>
			<div className="messages-btn-group">
				<button
					className="uk-button hms-simple-icon-btn inbox-read-state-indicator"
					type="button"
					disabled={!canManage || readPending}
					aria-busy={readPending}
					uk-tooltip={isUnread ? "Mark as Read" : "Mark as Unread"}
					onClick={(e) => {
						e.stopPropagation();
						setPersonalMeta(reservation.thread_id, "unread", !isUnread);
					}}
				>
					{readPending ? (
						<span uk-spinner="ratio: 0.6" aria-label="Updating read status" />
					) : isUnread ? (
						<FeatherIcon
							name="eye-off"
							className="inbox-action-icon inbox-read-state-icon"
							color="inherit"
						/>
					) : (
						<FeatherIcon
							name="eye"
							className="inbox-action-icon inbox-read-state-icon"
							color="inherit"
						/>
					)}
				</button>
				<button
					className={classnames("uk-button hms-simple-icon-btn", {
						"icon-active icon-priority":
							reservation.thread_meta?.indexOf("priority") >= 0,
					})}
					type="button"
					disabled={!canManage || priorityPending}
					aria-busy={priorityPending}
					uk-tooltip={
						reservation.thread_meta?.indexOf("priority") >= 0
							? "Unprioritize"
							: "Prioritize"
					}
					onClick={(event) => {
						event.stopPropagation();
						togglePersonalMeta(reservation.thread_id, "priority");
					}}
				>
					{priorityPending ? (
						<span uk-spinner="ratio: 0.6" aria-label="Updating priority" />
					) : (
						<FeatherIcon
							name="flag"
							className="inbox-action-icon"
							color="inherit"
						/>
					)}
				</button>
				<button
					className={classnames("uk-button hms-simple-icon-btn", {
						"icon-active icon-archived":
							reservation.thread_meta?.indexOf("archived") >= 0,
					})}
					type="button"
					disabled={!canManage || archivePending}
					aria-busy={archivePending}
					uk-tooltip={
						reservation.thread_meta?.indexOf("archived") >= 0
							? "Unarchive"
							: "Archive"
					}
					onClick={(event) => {
						event.stopPropagation();
						togglePersonalMeta(reservation.thread_id, "archived");
					}}
				>
					{archivePending ? (
						<span uk-spinner="ratio: 0.6" aria-label="Updating archive status" />
					) : (
						<FeatherIcon
							name="archive"
							className="inbox-action-icon"
							color="inherit"
						/>
					)}
				</button>
			</div>
		</div>
	);
};
